module.exports = __webpack_public_path__ + "img/login_background.bed76334.jpeg";